/**
 * /purchase-orders/:poId — Purchase Order detail page.
 * Delegates entirely to the <PODetail> component.
 */
import { createFileRoute } from "@tanstack/react-router";
import { useConstructionPack } from "@/lib/useConstructionPack";
import { PODetail } from "@/components/PODetail";

export const Route = createFileRoute("/_auth/purchase-orders/$poId")({
  component: PODetailPage,
});

function PODetailPage() {
  const { enabled: constructionEnabled } = useConstructionPack();
  if (!constructionEnabled) return null;
  const { poId } = Route.useParams();
  return <PODetail poId={poId} />;
}
